module.exports = __webpack_public_path__ + "media/images/cms/img_slide_05-6d9306482fb8903a9391e565d7978958.jpg";